<h3 class="title">{{ titleKey | translate }}</h3>
<p class="description">{{ descriptionKey | translate }}</p>

<div class="loading-state" *ngIf="loading" data-cy="category-loading">
  <mat-progress-spinner diameter="32" mode="indeterminate"></mat-progress-spinner>
</div>

<div class="empty-state" *ngIf="!loading && items.length === 0" data-cy="category-empty">
  {{ 'pipeline_step_editor.categories.empty' | translate }}
</div>

<ul class="list" *ngIf="!loading && items.length > 0" cdkDropList (cdkDropListDropped)="onDrop($event)">
  <li
    class="row"
    [class.row--undefined-label]="item.undefinedLabel"
    *ngFor="let item of items; trackBy: trackByUuid"
    cdkDrag
    [cdkDragDisabled]="!canEdit || pendingRemovalUuid !== null"
    cdkDragLockAxis="y"
    [attr.data-cy]="'category-row'"
  >
    <span class="row__label">
      <span class="row__name">{{ item.name }}</span>
      <span class="row__uuid">{{ item.uuid }}</span>
    </span>

    <span class="row__confirm-text" *ngIf="pendingRemovalUuid === item.uuid">
      {{ 'pipeline_step_editor.categories.confirm_delete' | translate }}
    </span>

    <ng-container *ngIf="pendingRemovalUuid !== item.uuid; else confirmActionsTpl">
      <ng-container *ngIf="canEdit; else readOnlyActionsTpl">
        <span class="row__actions">
          <button type="button" class="icon-button" (click)="editClicked.emit(item)" data-cy="category-edit">
            <i class="ri-pencil-line"></i>
          </button>
          <button
            type="button"
            class="icon-button icon-button--danger"
            (click)="requestRemove(item)"
            data-cy="category-remove"
          >
            <i class="ri-close-line"></i>
          </button>
        </span>
      </ng-container>
      <ng-template #readOnlyActionsTpl>
        <span class="row__actions">
          <button
            type="button"
            class="icon-button"
            (click)="visualizeClicked.emit(item)"
            data-cy="category-visualize"
          >
            <i class="ri-eye-line"></i>
          </button>
        </span>
      </ng-template>
    </ng-container>

    <ng-template #confirmActionsTpl>
      <span class="row__actions">
        <button type="button" class="btn btn-flat" (click)="cancelRemove()" data-cy="category-remove-cancel">
          {{ 'button.cancel' | translate }}
        </button>
        <button type="button" class="btn btn-danger" (click)="confirmRemove(item)" data-cy="category-remove-confirm">
          {{ 'button.confirm' | translate }}
        </button>
      </span>
    </ng-template>
  </li>
</ul>

<button
  *ngIf="!loading && canEdit && canAdd"
  type="button"
  class="btn btn-primary add-button"
  (click)="addClicked.emit()"
  data-cy="category-add"
>
  <i class="ri-add-circle-line"></i>
  {{ 'pipeline_step_editor.categories.add_button' | translate }}
</button>
